import '../stylesheets/style.scss'
import './existing-scripts'
import initBlog from './custom/blog'

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initBlog)
} else {
	initBlog()
}
